import { PublicProductCardDto } from "../Types/ProductCardRenderingTypes";
import { apiGet, apiPost, apiPublicGet, apiPut } from "./apiClient";

export interface CourseProductCardDto {
  courseId: number;
  price: string;
  rating: number;
  instructor: string;
  thumbnailImageUrl?: string;
  bannerImageUrl?: string;
  stripeProductId?: string | null;
  stripePriceId?: string | null;
  status: number;
}
export const GetMarketplaceProductCards = async (): Promise<PublicProductCardDto[]> => {
  return await apiPublicGet<PublicProductCardDto[]>("/ProductCard/storefront");
};
export const GetProductCardByCourseId = async (courseId: number) => {
  return await apiGet<CourseProductCardDto>(`/ProductCard/${courseId}`);
};

export const UpdateProductCard = async (
  courseId: number,
  data: Partial<CourseProductCardDto>
) => {
  return await apiPut(`/ProductCard/${courseId}`, data);
};

export const CreateProductCard = async (data: CourseProductCardDto) => {
  return await apiPost(`/ProductCard`, data);
};

export const SyncProductCardStripe = async (courseId: number) => {
  return await apiPost<CourseProductCardDto>(`/ProductCard/${courseId}/sync-stripe`, {});
};

export const SyncAllProductCardsStripe = async () => {
  return await apiPost<CourseProductCardDto[]>(`/ProductCard/sync-stripe-all`, {});
};

export const uploadProductCardImage = async (
  courseId: number,
  file: File,
  type: "thumbnail" | "banner"
): Promise<string | null> => {
  const formData = new FormData();
  formData.append("file", file);

  const endpoint =
    type === "thumbnail"
      ? `/ProductCard/${courseId}/upload-thumbnail`
      : `/ProductCard/${courseId}/upload-banner`;

  const res = await fetch(
    `${process.env.REACT_APP_API_URL}${endpoint}`,
    {
      method: "POST",
      credentials: "include",
      body: formData
    }
  );

  if (!res.ok) return null;

  const json = await res.json();
  return json.url;
};
